import { custom, date, nonEmpty, nullable, number, object, optional, pipe, string } from 'valibot';

export const ADD_AI_FIELDS = {
  OPTION: 'option',
  TYPE: 'type',
  DESCRIPTION: 'description',
  INSTALLATION_POINT: 'installation_point',
  URGENCY: 'urgency',
  EQUIPMENT_TYPE: 'equipment_type',
  POINT_INFO: 'point_info',
  IS_ADVANCED_SEARCH: 'is_advanced_search',
  ADVANCE_LOCATION_ID: 'advanceLocationId',
  ADVANCE_EQUIPMENT: 'advanceEquipment',
  APPROXIMATE_DATE: 'approximate_date',
};
export const schemaAddAiOption = object({
  [ADD_AI_FIELDS.OPTION]: pipe(string(), nonEmpty('Select an option')),
});

export const schemaAddAiType = object({
  [ADD_AI_FIELDS.TYPE]: pipe(string(), nonEmpty('Select the action item type')),
});

export const schemaAddAiPointSelect = object({
  [ADD_AI_FIELDS.INSTALLATION_POINT]: pipe(
    object(
      {
        id: number('Select an option'),
        serial: optional(number()),
        activeWwAi: optional(nullable(number())),
        activeRegularAi: optional(nullable(number())),
        facilityId: optional(number()),
        facilityOffset: optional(number()),
      },
      'This field is required.',
    ),
    custom(
      (value) => !value.activeRegularAi,
      'An Action Item is currently open for this installation point that must be addressed before you can open a new one.',
    ),
  ),
});

export const schemaAddAiPointSelectWithEquipmentType = object({
  [ADD_AI_FIELDS.INSTALLATION_POINT]: pipe(
    object(
      {
        id: number('Select an option'),
        serial: optional(number()),
        activeWwAi: optional(nullable(number())),
        activeRegularAi: optional(nullable(number())),
        facilityId: optional(number()),
        facilityOffset: optional(number()),
      },
      'This field is required.',
    ),
    custom(
      (value) => !value.activeWwAi,
      'An Action Item is currently open for this installation point that must be addressed before you can open a new one.',
    ),
  ),
  [ADD_AI_FIELDS.EQUIPMENT_TYPE]: object(
    {
      id: string('Select an option'),
      name: optional(string()),
    },
    'This field is required.',
  ),
});

export const schemaAddAiDetails = object({
  [ADD_AI_FIELDS.DESCRIPTION]: pipe(string(), nonEmpty('This field is required.')),
  [ADD_AI_FIELDS.URGENCY]: pipe(number(), nonEmpty('This field is required.')),
});

export const schemaAddAiDetailsWithDate = object({
  ...schemaAddAiDetails.entries,
  [ADD_AI_FIELDS.APPROXIMATE_DATE]: date('This field is required.'),
});

export const getAddAiDefaultValues = (filledData) => {
  const urgencyValue = filledData?.urgency === 'Caution' ? 2 : 3;

  return {
    [ADD_AI_FIELDS.OPTION]: filledData?.option || '',
    [ADD_AI_FIELDS.TYPE]: filledData?.aiType || '',
    [ADD_AI_FIELDS.EQUIPMENT_TYPE]: filledData?.equipmentType || { id: null },
    [ADD_AI_FIELDS.INSTALLATION_POINT]: filledData?.installationPoint || { id: null },
    [ADD_AI_FIELDS.IS_ADVANCED_SEARCH]: false,
    [ADD_AI_FIELDS.ADVANCE_LOCATION_ID]: null,
    [ADD_AI_FIELDS.ADVANCE_EQUIPMENT]: { id: null },
    [ADD_AI_FIELDS.DESCRIPTION]: '',
    [ADD_AI_FIELDS.URGENCY]: urgencyValue,
    [ADD_AI_FIELDS.APPROXIMATE_DATE]: null,
  };
};
